"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnHelper = void 0;
var lodash_1 = __importDefault(require("lodash"));
var models_1 = require("../../models");
exports.ColumnHelper = {
    GetColumnHeaders: function (columns) {
        var _this = this;
        return lodash_1.default.map(this.GetSelectedColumns(columns), function (c) { return _this.GetColumnHeaderFromColumn(c); });
    },
    GetColumnHeaderFromColumn: function (column) {
        var columnHeader = {
            label: column.displayText,
            field: column.name,
            isSortable: column.isSortable,
            sortAscByDefault: column.sortAscByDefault,
        };
        return columnHeader;
    },
    GetSelectedColumns: function (columns) {
        return lodash_1.default.filter(columns, function (c) { return c.checked; });
    },
    GetSelectedColumnNames: function (columns) {
        var selectedColumns = this.GetSelectedColumns(columns);
        return lodash_1.default.map(selectedColumns, function (c) { return c.name; });
    },
    UpdateSelectedColumns: function (columns, values) {
        return lodash_1.default.map(columns, function (c) {
            c.checked = values.indexOf(c.name) > -1;
            return c;
        });
    },
    GetSourceTypeContent: function (sourceType) {
        switch (sourceType) {
            case models_1.SourceType.Custom:
                return 'Custom';
            case models_1.SourceType.ClientLibrary:
                return 'My Company Library';
            default:
                return 'Kincentric Library';
        }
    },
    GetStatusContent: function (publicationStatus) {
        switch (publicationStatus) {
            case 3:
                return models_1.PublicationStatus.Inactive;
            case 2:
                return models_1.PublicationStatus.Public;
            default:
                return models_1.PublicationStatus.Draft;
        }
    },
};
